import React, { useState, useRef, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { toast } from "react-toastify";

import * as billPaymentActions from "store/entities/billPayment/action";

import BillerSelector from 'components/__new/billPayment/BillerSelector';
import { ButtonLoader, Input } from 'components/__new/common/form';
import FormDrawer from 'components/__new/common/form-drawer';
import useLoginInfo from 'hooks/useLoginInfo';
import useTransformedProviders from 'hooks/useTransformedProviders';
import ModalAlert from 'components/__new/common/ModalAlert';
import validate from "utils/validate";
import { REGEX_VALUES } from 'utils/regexValues';


const EditAirtimeDataBeneficiary = ({ providerData, isOpen, setIsOpen, toggleEditModal, getAllBeneficiaries, viewAirtimeDataBeneficiary: beneficiary }) => {
    const dispatch = useDispatch();
    const searchableBillersRef = useRef();
    const {userInfo} = useLoginInfo();
    
    const {editBeneficiaryLoading, editBeneficiary} = useSelector((s) => s.entities.billPayment);
    const [isOpenModalAlertSuccess , setIsOpenModalAlertSuccess] = useState(false)
    const [isEdited, setIsEdited] = useState(false)
    
    const [form, setForm] = useState({
        network: {},
        phoneNumber: "",
        alias: "",
        product: "",
    });
    
        
    // const airtimeBiller = useTransformedProviders(providerData?.airtime, beneficiary?.product)
    // const dataBiller = useTransformedProviders(providerData?.data, beneficiary?.product)
    // const biller = {...airtimeBiller, ...dataBiller}
    const {transformedData: biller, setTransformedData: setBiller} = useTransformedProviders(providerData?.data, beneficiary?.product)
    
    const handleNameChange = (e) => {
        const { name, value } = e.target;
        if ((name === "alias") && (!REGEX_VALUES.LETTERS_WITH_UNDERSCORE_AMPERSAND_AND_HYPHEN_ONLY.test(value) || value.length > 50)) {
          return;
        }
        setForm({...form, [name]: value})
      }
    
    
    const handleAccountChange = (e) => {
        const { value } = e.target;
        if ((value.length !== 12) && (value >= 0)) {
            setForm({...form, phoneNumber: value})
        }
    }

    const submitForm = (e) => {
        e.preventDefault();
        
        const validateForm = {...form};
        delete validateForm["network"];
        delete validateForm["product"];
        delete validateForm["alias"];
    
        const errors = validate(validateForm);
        if (errors){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            const params = {
                phoneNumber: form.phoneNumber,
                alias: form.alias,
                product: form.network?.value,
                service: 'data',
                businessId: userInfo?.employer?._id,
            }
            
            dispatch(billPaymentActions.editBeneficiary(params, beneficiary?._id))
            setIsEdited(true)
        }
    }
    
// const lengthValidation = form?.phoneNumber?.length === 11
const disableSubmit = form?.phoneNumber?.length !== 11;

    
    
    
const currentValues = useMemo(
    () => ({
            alias: beneficiary?.alias || "",
            phoneNumber: beneficiary?.phoneNumber || "",
            product: beneficiary?.product || "",
            
    }), [beneficiary]
)

useEffect(() => {
    if(biller){
        setForm({...currentValues, network: biller});
        searchableBillersRef.current?.setSelectedOption(biller)
        setBiller(null)
    }
}, [biller, currentValues, setBiller]);

    useEffect(() => {
        setForm({...currentValues})
    }, [beneficiary]);
  
useEffect(() => {
    if(editBeneficiary?.status === 'success' && isEdited === true) {
        getAllBeneficiaries();
        setIsEdited(false);
        setIsOpen(false);
        toast.success(editBeneficiary?.message);
    }
    // eslint-disable-next-line
}, [editBeneficiary]);  


    
    return (
        <>
            <ModalAlert
                successText={editBeneficiary?.message || 'Congratulations! Your beneficiaries have been saved successfully'}
                dismissText="Close"
                isOpenModalAlert={isOpenModalAlertSuccess}
                setIsOpenModalAlert={setIsOpenModalAlertSuccess}
            />
            <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={() => {}}>
                
                <div className='w-full p-6'>
                    <FormDrawer.Title
                        close={setIsOpen}
                        showCloseButton={true}
                        title="Edit Beneficiary"
                        description="Make changes to this beneficiary"
                    />
                
                    <form onSubmit={submitForm}>
                        <div className="w-full mt-5">
                            
                            <Input
                                type="text"
                                label="Beneficiary Name"
                                value={form?.alias}
                                className="form-input"
                                placeholder="Enter name"
                                name="alias"
                                onChange={handleNameChange}
                            />
                            
                            <div className="relative">
                                <BillerSelector
                                    type="data"
                                    label="Biller"
                                    tag="networks"
                                    ref={searchableBillersRef}
                                    onValueChange={(e) => setForm({...form, network: e})}
                                />
                            </div>

                            <div className="form-group relative">
                                <label>Phone Number</label>
                                <input
                                    type="number"
                                    id="prl-input"
                                    className="form-input"
                                    value={form.phoneNumber}
                                    placeholder="Enter phone number"
                                    // onChange={(e) => setForm({...form, phoneNumber: e.target.value})}
                                    onChange={handleAccountChange}
                                />
                                
                            </div>
                        </div>
                        
                        <div className="border-t w-full flex items-center justify-end mt-7 pt-5">
                            <button type="button" onClick={() => setIsOpen(false)} className="btn btn-transparent-primary mr-3">
                                Cancel
                            </button>
                            
                            <ButtonLoader type="submit" loading={editBeneficiaryLoading} disabled={disableSubmit} className="btn btn-ep-primary">
                                Save Changes
                            </ButtonLoader>
                        </div>
                    </form>
                </div>
            
            </FormDrawer>
        </>
    )
}


export default EditAirtimeDataBeneficiary
